"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports.useQueries = useQueries;

var _react = _interopRequireDefault(require("react"));

var _useSyncExternalStore = require("./useSyncExternalStore");

var _notifyManager = require("../core/notifyManager");

var _queriesObserver = require("../core/queriesObserver");

var _QueryClientProvider = require("./QueryClientProvider");

var _isRestoring = require("./isRestoring");

function useQueries(_ref) {
  var queries = _ref.queries,
      context = _ref.context;
  var queryClient = (0, _QueryClientProvider.useQueryClient)({
    context: context
  });
  var isRestoring = (0, _isRestoring.useIsRestoring)();

  var defaultedQueries = _react["default"].useMemo(function () {
    return queries.map(function (options) {
      var defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options

      defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic';
      return defaultedOptions;
    });
  }, [queries, queryClient, isRestoring]);

  var _react$default$useSta = _react["default"].useState(function () {
    return new _queriesObserver.QueriesObserver(queryClient, defaultedQueries);
  }),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 1),
      observer = _react$default$useSta2[0];

  var result = observer.getOptimisticResult(defaultedQueries);
  (0, _useSyncExternalStore.useSyncExternalStore)(_react["default"].useCallback(function (onStoreChange) {
    return isRestoring ? function () {
      return undefined;
    } : observer.subscribe(_notifyManager.notifyManager.batchCalls(onStoreChange));
  }, [observer, isRestoring]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });

  _react["default"].useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setQueries(defaultedQueries, {
      listeners: false
    });
  }, [defaultedQueries, observer]);

  return result;
}